import { render, staticRenderFns } from "./GlobalTable.vue?vue&type=template&id=ec75384c&"
import script from "./GlobalTable.vue?vue&type=script&lang=js&"
export * from "./GlobalTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTable.vue?vue&type=style&index=0&id=ec75384c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports